import { render, staticRenderFns } from "./AngleLeftSvg.vue?vue&type=template&id=1c93a53c&scoped=true&"
import script from "./AngleLeftSvg.vue?vue&type=script&lang=js&"
export * from "./AngleLeftSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c93a53c",
  null
  
)

export default component.exports